<div class="modal-dialog modal-dialog_how-it-works">
  <div class="modal__content">
    <button class="modal__close"
      (click)="dialogRef.close()"
    ></button>

    <div class="modal__header">
      <div class="modal__title" i18n="@@profile.need_play_games.title1">Как это работает?</div>
    </div>

    <div class="how-it-works">
      <div class="collapsibles collapsibles_filled is-open">
        <div class="collapsibles__head">
          <div class="collapsibles__title" i18n="@@profile.need_play_games.title2">Как снимаются отыгровки?</div>
          <div class="collapsibles__icon"></div>
        </div>

        <div class="collapsibles__content">
          <div class="collapsibles__informer">
            <ng-container i18n="@@profile.need_play_games.subtitle">1 выигранная или проигранная игра =</ng-container> <span class="sand" i18n="@@profile.need_play_games.one_wager">1 отыгровка</span>
          </div>

          <p class="subtitle" i18n="@@profile.need_play_games.additional_rules">Дополнительные условия</p>

          <div class="mode-informer">
            <div class="mode-informer__title">
              <i class="icon icon_crash"></i> Crash
            </div>

            <div class="mode-informer__text">
              <p i18n="@@profile.need_play_games.crash">Отыгрыш засчитывается при ставке с коэфф. выше x1.25</p>
            </div>
          </div>

          <div class="mode-informer">
            <div class="mode-informer__title">
              <i class="icon icon_defuse-bomb"></i> Defuse
            </div>

            <div class="mode-informer__text">
              <p i18n="@@profile.need_play_games.crash">Отыгрыш засчитывается при ставке с коэфф. выше x1.25</p>
            </div>
          </div>

          <div class="mode-informer">
            <div class="mode-informer__title">
              <i class="icon icon_mine-alt"></i> Mines
            </div>

            <div class="mode-informer__text">
              <p i18n="@@profile.need_play_games.crash">Отыгрыш засчитывается при ставке с коэфф. выше x1.25</p>
            </div>
          </div>

          <div class="mode-informer">
            <div class="mode-informer__title">
              <i class="icon icon_jackpot"></i> Jackpot
            </div>

            <div class="mode-informer__text">
              <p i18n="@@profile.need_play_games.jackpot">Отыгрыш в данном режиме невозможен</p>
            </div>
          </div>

          <div class="mode-informer">
            <div class="mode-informer__title">
              <i class="icon icon_wheel"></i> Wheel
            </div>

            <div class="mode-informer__text">
              <p i18n="@@profile.need_play_games.wheel">Отыгрыш засчитывается при любой ставке</p>
            </div>
          </div>

          <div class="mode-informer">
            <div class="mode-informer__title">
              <i class="icon icon_double"></i> Double
            </div>

            <div class="mode-informer__text">
              <p i18n="@@profile.need_play_games.double">Невозможно совершить более одной ставки с активным отыгрышем</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
